import {
    Box, Button, Grid, MenuItem, Select, FormControl,
    InputLabel, Snackbar, Divider, Typography, Checkbox,
    Dialog, DialogTitle, DialogContent, DialogActions, TextField,
    Grid2
} from "@mui/material";
import TokenError from "../tokenError";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { makeGetRequestToUrl, makePostRequestToUrl } from '../commonFunc.jsx';
import config from '../../config/config.js';
import { useNavigate } from "react-router-dom";

const ShuttleHoliday = () => {
    const today = new Date();
    const years = [today.getFullYear(), today.getFullYear() + 1];

    const months = [
        { value: 1, label: "January" }, { value: 2, label: "February" },
        { value: 3, label: "March" }, { value: 4, label: "April" },
        { value: 5, label: "May" }, { value: 6, label: "June" },
        { value: 7, label: "July" }, { value: 8, label: "August" },
        { value: 9, label: "September" }, { value: 10, label: "October" },
        { value: 11, label: "November" }, { value: 12, label: "December" },
    ];

    const HOLIDAY_COLORS = [
        { bg: '#E3F2FD', text: '#0D47A1' }, // Light Blue
        { bg: '#E8F5E9', text: '#1B5E20' }, // Light Green
        { bg: '#FFF3E0', text: '#E65100' }, // Light Orange
        { bg: '#F3E5F5', text: '#4A148C' }, // Light Purple
        { bg: '#E0F7FA', text: '#006064' }, // Light Teal
        { bg: '#FFF8E1', text: '#FF6F00' }, // Light Amber
        { bg: '#F1F8E9', text: '#33691E' }, // Light Green 2
        { bg: '#FCE4EC', text: '#880E4F' }, // Light Pink
        { bg: '#E8EAF6', text: '#1A237E' }, // Light Indigo
    ];

    const getHolidayColorByIndex = (index) => {
        return HOLIDAY_COLORS[index % HOLIDAY_COLORS.length];
    };

    const getHolidayColor = (title) => {
        if (!title) return { bg: 'transparent', text: 'inherit' };
        const index = Math.abs(title.split('').reduce((a, b) => a + b.charCodeAt(0), 0)) % HOLIDAY_COLORS.length;
        return HOLIDAY_COLORS[index];
    };
    
    

    const navigate = useNavigate();
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;

    const token = localStorage.getItem("token");
    const cities = JSON.parse(localStorage.getItem("cities")) || [];
    const [allHolidays, setAllHolidays] = useState({}); // { "2025-08": [...holidays], "2025-09": [...] }

    const [tokenExpired, setTokenExpired] = useState(false);
    const [cityFilter, setCityFilter] = useState(cities[0]?.city_id || "");
    const [selectedYear, setSelectedYear] = useState(today.getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(today.getMonth() + 1);

    const [checkedDays, setCheckedDays] = useState([]); // backend holiday format
    const [clientid, setClientid] = useState("");

    const [openTitleModal, setOpenTitleModal] = useState(false);
    const [selectedDay, setSelectedDay] = useState(null);
    const [title, setTitle] = useState("");

    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState("");

    const formatDate = (day, month, year) =>
        `${String(day).padStart(2, "0")}-${String(month).padStart(2, "0")}-${year}`;

    const isDayChecked = (day) => {
        const dateStr = formatDate(day, selectedMonth, selectedYear);
        return checkedDays.some((d) => d.date === dateStr);
    };

    const getDayName = (year, month, day) => {
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString("en-US", { weekday: "long" });
    };

    const getMonthLabel = () =>
        months.find((m) => m.value === selectedMonth)?.label || "";

    const getDaysInMonth = () => {
        const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
        return Array.from({ length: daysInMonth }, (_, i) => i + 1);
    };

    const handleDayCheck = (day, customTitle = "") => {
        const dateStr = formatDate(day, selectedMonth, selectedYear);
        setCheckedDays((prev) => {
            if (prev.some((d) => d.date === dateStr)) {
                // remove
                return prev.filter((d) => d.date !== dateStr);
            } else {
                // add
                return [...prev, { title: customTitle, date: dateStr }];
            }
        });
    };

    console.log(selectedMonth,selectedYear,"selectedMonth,selectedYear")

    const handleEditClick = (day) => {
        const dateStr = formatDate(day, selectedMonth, selectedYear);
        const holiday = checkedDays.find((d) => d.date === dateStr);
        setSelectedDay(day);
        setTitle(holiday?.title || "");
        setOpenTitleModal(true);
    };

    const handleSaveTitle = () => {
        if (selectedDay) {
            const dateStr = formatDate(selectedDay, selectedMonth, selectedYear);
            const isChecked = checkedDays.some(day => day.date === dateStr);
            
            // If the day is already checked, update the title
            if (isChecked) {
                setCheckedDays(prev => 
                    prev.map(day => 
                        day.date === dateStr 
                            ? { ...day, title: title || 'Holiday' } 
                            : day
                    )
                );
            } 
            // If not checked, add it as a new holiday
            else {
                handleDayCheck(selectedDay, title || 'Holiday');
            }
        }
        setOpenTitleModal(false);
    };


    const handleCityChange = (e) => {
        setCityFilter(e);
    };

    const handleYearChange = (event) => {
        setAllHolidays({});
        setClientid("");
        setSelectedYear(event.target.value);
    };
    
    const handleMonthChange = (event) => {
        setAllHolidays({});
        setClientid("");
        setSelectedMonth(event.target.value);
    };

    useEffect(() => {
        if (cityFilter) {
            const monthKey = `${selectedYear}-${String(selectedMonth).padStart(2, '0')}`;
            
            // If we have data for this month, use it
            if (allHolidays[monthKey]) {
                setCheckedDays(allHolidays[monthKey]);
            } 
            // Otherwise fetch the data
            // else {
                fetchHolidayData();
            // }
        }
    }, [selectedYear, selectedMonth, cityFilter]);

    const styles = {
        holidayTitle: {
            display: 'inline-flex',
            alignItems: 'center',
            padding: '2px 8px',
            borderRadius: '12px',
            marginLeft: '8px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '120px',
            fontSize: '0.75rem',
            fontWeight: 500,
            lineHeight: 1.5,
        }
    };

    const handleSnackbarClose = () => showSnackbar(false);

    const fetchHolidayData = async () => {
        try {
            const url = `${serverUrl}/shuttle/fetch_shuttle_holidays`;
            const body = { token, city_id: cityFilter, timestamp: Date.now(),month: selectedMonth,year: selectedYear };
            const response = await makeGetRequestToUrl(url, body);
    
            if (response.flag === 200) {
                const monthKey = `${selectedYear}-${String(selectedMonth).padStart(2, '0')}`;
                const holidays = response.data[0]?.holidays || [];
                
                setAllHolidays(prev => ({
                    ...prev,
                    [monthKey]: holidays
                }));
                
                setCheckedDays(holidays);
                
                if (response.data[0]?.id) {
                    setClientid(response.data[0].id);
                }
            }
            // ... rest of your error handling
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const handleSubmit = async () => {
        const monthKey = `${selectedYear}-${String(selectedMonth).padStart(2, '0')}`;
        const payload = {
            token,
            city_id: cityFilter,
            holidays: checkedDays, // send directly
            month: selectedMonth,
            year: selectedYear
        };
        if(clientid){
            payload.id = clientid;
        }

        try {
            const url = `${operationsUrl}/shuttle/add_update_shuttle_holidays`;
            const response = await makePostRequestToUrl(url, payload);

            if (response.flag === 200) {
                setAllHolidays(prev => ({
                    ...prev,
                    [monthKey]: [...checkedDays]
                }));
                setMessage("Saved successfully!");
                fetchHolidayData();
            } else if (response.flag === 102) {
                localStorage.removeItem("token");
                setTokenExpired(true);
                setMessage("Your session has expired. Please log in again.");
                setTimeout(() => navigate("/signup"), 2000);
            } else {
                setMessage(response.message);
            }
        } catch (error) {
            console.error("Save error:", error);
            setMessage("Error while saving document.");
        } finally {
            showSnackbar(true);
        }
    };

    return (
        <div>
            {tokenExpired && <TokenError />}

            <Typography style={{ fontSize: "28px", fontWeight: "500" }}>
                Holiday List
            </Typography>

            <Grid2 container spacing={2} sx={{ marginTop: "2%" }}>
                <Grid2 item>
                    <Select
                        value={cityFilter}
                        onChange={(e) => handleCityChange(e.target.value)}
                        displayEmpty
                        style={{
                            width: "190px",
                            height: "50px",
                            borderRadius: "8px",
                            backgroundColor: cityFilter ? "#F9F9F9" : "#FFFFFF",
                        }}
                    >
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <FormControl sx={{ flex: 1 }}>
                        <InputLabel id="year-select-label">Year</InputLabel>
                        <Select
                            labelId="year-select-label"
                            id="year-select"
                            value={selectedYear}
                            label="Year"
                            onChange={handleYearChange}
                            style={{
                                width: "190px",
                                height: "50px",
                                borderRadius: "8px",
                                backgroundColor: selectedYear ? "#F9F9F9" : "#FFFFFF",
                            }}
                        >
                            <MenuItem value="">
                                <em>Select Year</em>
                            </MenuItem>
                            {years.map((year) => (
                                <MenuItem key={year} value={year}>
                                    {year}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid2>
                <Grid2 item>
                    <FormControl sx={{ flex: 1 }}>
                        <InputLabel id="month-select-label">Month</InputLabel>
                        <Select
                            labelId="month-select-label"
                            id="month-select"
                            value={selectedMonth}
                            label="Month"
                            onChange={handleMonthChange}
                            style={{
                                width: "190px",
                                height: "50px",
                                borderRadius: "8px",
                                backgroundColor: selectedMonth ? "#F9F9F9" : "#FFFFFF",
                            }}
                        >
                            <MenuItem value="">
                                <em>Select Month</em>
                            </MenuItem>
                            {months.map((month) => (
                                <MenuItem key={month.value} value={month.value}>
                                    {month.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid2>
            </Grid2>

            <Grid2 sx={{ marginTop: "2%" }}>
                {selectedYear && selectedMonth && (
                    <Box
                        sx={{
                            maxWidth: "100vw",
                            backgroundColor: "#F9F9F9",
                            borderRadius: "8px",
                            border: "1px solid #E0E0E0",
                            padding: "16px",
                        }}
                    >
                        <Typography variant="h6" sx={{ marginBottom: "7px" }}>
                            Days in {getMonthLabel()} {selectedYear}
                        </Typography>
                        <Divider />
                        <Grid className="table-container" container spacing={2} sx={{ marginTop: "1%", marginLeft: "2px" }} style={{ border: "1px solid rgb(249, 249, 249)" }}>
                            {getDaysInMonth().map((day) => {
                                const isDisabled =
                                    selectedYear === today.getFullYear() &&
                                    (selectedMonth < today.getMonth() + 1 ||
                                        (selectedMonth === today.getMonth() + 1 && day < today.getDate()));

                                const dateStr = formatDate(day, selectedMonth, selectedYear);
                                const index = checkedDays.findIndex((d) => d.date === dateStr);
                                const holiday = index !== -1 ? checkedDays[index] : null;
                                const color = index !== -1 ? getHolidayColorByIndex(index) : null;

                                return (
                                    <Grid
                                        item
                                        xs={2.2}
                                        key={day}
                                        sx={{
                                            border: "1px solid #aaa",
                                            borderRadius: "8px",
                                            padding: "12px",
                                            margin: "4px",
                                            minHeight: "140px",
                                            marginLeft: "10px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            backgroundColor: holiday ? color.bg : (isDisabled ? '#24282F20' : 'transparent'),
                                            transition: 'background-color 0.3s ease',
                                            '&:hover': {
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                            }
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start',
                                                width: '100%'
                                            }}
                                        >
                                            <Typography
                                                variant="h4"
                                                sx={{
                                                    fontWeight: "semibold",
                                                    color: holiday ? getHolidayColor(holiday.title).text : 'inherit'
                                                }}
                                            >
                                                {day}
                                            </Typography>
                                            {holiday && (
                                                <Typography
                                                variant="subtitle2"
                                                sx={{
                                                    ...styles.holidayTitle,
                                                    color: color.text,
                                                    backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                                    
                                                }}
                                                {...holiday.title ? { border: `1px solid ${color.text}30`} : { border: 'none' }}
                                            >
                                                {holiday.title ? holiday.title : ''}
                                            </Typography>
                                            )}
                                        </Box>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: holiday ? getHolidayColor(holiday.title).text : "#666",
                                                    fontWeight: holiday ? 500 : 'normal'
                                                }}
                                            >
                                                {getDayName(selectedYear, selectedMonth, day)}
                                            </Typography>
                                            {!isDisabled && (
                                                <Grid2 container alignItems="center" sx={{ display: 'flex', gap: 1 }}>
                                                    <EditIcon
                                                        onClick={() => handleEditClick(day)}
                                                        sx={{
                                                            color: holiday ? getHolidayColor(holiday.title).text : '#2563EB',
                                                            cursor: 'pointer'
                                                        }}
                                                    />
                                                    <Checkbox
                                                        checked={isDayChecked(day)}
                                                        onChange={() => handleDayCheck(day)}
                                                        sx={{
                                                            color: holiday ? getHolidayColor(holiday.title).text : 'primary',
                                                            '&.Mui-checked': {
                                                                color: holiday ? getHolidayColor(holiday.title).text : 'primary',
                                                            },
                                                        }}
                                                    />
                                                </Grid2>
                                            )}
                                        </Box>
                                    </Grid>
                                );
                            })}
                        </Grid>

                        {/* Save button aligned right */}
                        <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: 2 }}>
                            <Button
                                variant="contained"
                                style={{
                                    width: "190px",
                                    height: "50px",
                                    backgroundColor: "#2563EB",
                                    textTransform: "none",
                                    borderRadius: "8px",
                                }}
                                onClick={() => {
                                    // Your save logic here
                                    handleSubmit();
                                    setMessage("Saved successfully!");
                                    showSnackbar(true);
                                }}
                            >
                                Save
                            </Button>
                        </Box>
                    </Box>
                )}
            </Grid2>
            <Dialog
                open={openTitleModal}
                onClose={() => setOpenTitleModal(false)}
                aria-labelledby="delete-booking-dialog-title"
                aria-describedby="delete-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px',
                        width: '400px',
                    }
                }}
            >
                <DialogTitle id="delete-booking-dialog-title" sx={{ fontWeight: 'bold' }}>Add Title for {selectedDay}/{selectedMonth}/{selectedYear}</DialogTitle>
                <DialogContent>
                    {/* <DialogContentText id="delete-booking-dialog-description">
                        Please enter the title for the holiday.
                    </DialogContentText> */}
                    <TextField
                        label="Please enter the title"
                        variant="outlined"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        sx={{
                            width: '100%',
                            marginTop: '16px',
                        }}
                    />
                </DialogContent>
                <DialogActions sx={{ paddingBottom: '20px', paddingRight: '20px' }}>
                    <Button
                        onClick={() => setOpenTitleModal(false)}
                        sx={{
                            color: '#6B7280',
                            borderRadius: '8px',
                            textTransform: 'none',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            handleSaveTitle();
                        }}
                        color="error"
                        variant="contained"
                        sx={{
                            backgroundColor: '#2563EB',
                            borderRadius: '8px',
                            textTransform: 'none',
                            '&:hover': {
                                backgroundColor: '#2563EB'
                            }
                        }}
                        autoFocus
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={snackbar}
                autoHideDuration={2000}
                onClose={handleSnackbarClose}
                message={message}
            />
        </div>
    );
};

export default ShuttleHoliday;


